import React from 'react';
import { SpeakerRole } from '../../types/speakerCorrection';

const ROLES: SpeakerRole[] = ['physician', 'patient', 'family', 'nurse', 'interpreter', 'other'];
const ROLE_DISPLAY: Record<SpeakerRole, string> = {
  physician: 'Physician',
  patient: 'Patient',
  family: 'Family Member',
  nurse: 'Nurse',
  interpreter: 'Interpreter',
  other: 'Other',
};

export interface SpeakerSummary {
  speakerId: string;
  role: SpeakerRole;
  displayName: string;
  segmentCount: number;
  confidence: number;
}

interface Props {
  speaker: SpeakerSummary;
  isLowConfidence: boolean;
  onRelabel: (speakerId: string, newRole: SpeakerRole, newDisplayName: string) => void;
  disabled?: boolean;
}

export function SpeakerRoleEditor({ speaker, isLowConfidence, onRelabel, disabled }: Props) {
  return (
    <div
      className={`flex items-center gap-3 p-3 rounded border ${isLowConfidence ? 'border-amber-400 bg-amber-50' : 'border-gray-200'}`}
      data-testid={`speaker-row-${speaker.speakerId}`}
    >
      <div className="flex-1">
        <div className="font-medium">{speaker.speakerId}</div>
        <div className="text-xs text-gray-500">
          {speaker.segmentCount} segments · confidence {(speaker.confidence * 100).toFixed(0)}%
        </div>
      </div>
      <select
        aria-label={`Role for ${speaker.speakerId}`}
        value={speaker.role}
        disabled={disabled}
        onChange={(e) => {
          const newRole = e.target.value as SpeakerRole;
          onRelabel(speaker.speakerId, newRole, ROLE_DISPLAY[newRole]);
        }}
        className="border rounded px-2 py-1 text-sm"
      >
        {ROLES.map((r) => (
          <option key={r} value={r}>{ROLE_DISPLAY[r]}</option>
        ))}
      </select>
    </div>
  );
}
